'use client';

import { useIntl } from 'react-intl';
import { Function } from 'effect';

import { CartQuantityDelta } from '@vs-shop/commerce-ui/cartDrawer';
import {
  ProductAmountCounter,
  ProductAmountCounterVariant,
} from '@vs-shop/ui/productAmountCounter';

type Props = {
  confirmedQuantity: number;
  pendingQuantity: number;
};

/** A pending add keeps the confirmed counter's width and reserves the delta badge. */
export function CartDrawerProjectedQuantity({ confirmedQuantity, pendingQuantity }: Props) {
  const intl = useIntl();

  return (
    <div
      data-slot="cart-drawer-projected-quantity"
      className="flex items-center gap-2"
      role="group"
      aria-label={intl.formatMessage(
        {
          id: 'cartDrawer.pendingLine.projectedQuantity',
          defaultMessage: 'Celkem {quantity} ks',
        },
        { quantity: confirmedQuantity + pendingQuantity }
      )}
    >
      <ProductAmountCounter
        amount={confirmedQuantity}
        onDecrementAction={Function.constVoid}
        onIncrementAction={Function.constVoid}
        onInputChangeAction={Function.constVoid}
        decrementDisabled
        incrementDisabled
        inputDisabled
        isLoading={false}
        decrementLabel={intl.formatMessage({
          id: 'component.client.product.productAmountCounter.decrementLabel',
          defaultMessage: 'Snížit počet',
        })}
        incrementLabel={intl.formatMessage({
          id: 'component.client.product.productAmountCounter.incrementLabel',
          defaultMessage: 'Zvýšit počet',
        })}
        amountLabel={intl.formatMessage({
          id: 'component.client.product.productAmountCounter.amountLabel',
          defaultMessage: 'Počet',
        })}
        variant={ProductAmountCounterVariant.TALL}
      />
      <CartQuantityDelta delta={pendingQuantity} aria-hidden="true" />
    </div>
  );
}
